import { render, staticRenderFns } from "./TemplateWrapper.vue?vue&type=template&id=25da862a&scoped=true"
import script from "./TemplateWrapper.vue?vue&type=script&lang=js"
export * from "./TemplateWrapper.vue?vue&type=script&lang=js"
import style0 from "./TemplateWrapper.vue?vue&type=style&index=0&id=25da862a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da862a",
  null
  
)

export default component.exports